<div class="container">
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
    <fieldset>
      <legend>Alterar senha</legend>
      <div>
        <mat-form-field class="full-input">
          <mat-label>Senha atual:</mat-label>
          <input matInput id="oldPassword" formControlName="oldPassword" type="password">
          @if (changePasswordForm.get('oldPassword')?.hasError('required') && (changePasswordForm.touched || changePasswordForm.dirty)) {
            <mat-error>O campo Ã© obrigatÃ³rio.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="hint-spacer">
        <mat-form-field class="full-input">
          <mat-label>Nova Senha:</mat-label>
          <input matInput id="newPassword" formControlName="newPassword" type="password">
          <mat-hint>Senha deve ter 8 caracteres, pelo menos uma letra maiÃºscula, uma letra minÃºscula, um nÃºmero e um caractere especial.</mat-hint>
          @if (changePasswordForm.get('newPassword')?.hasError('required') && (changePasswordForm.touched || changePasswordForm.dirty)) {
            <mat-error>O campo Ã© obrigatÃ³rio.</mat-error>
          }
          @if (changePasswordForm.get('newPassword')?.hasError('pattern')) {
            <mat-error>A senha deve ter pelo menos 8 caracteres, incluir uma letra maiÃºscula, uma minÃºscula, um nÃºmero e um caractere especial.</mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="full-input">
          <mat-label>Confirmar Nova Senha:</mat-label>
          <input matInput id="confirmNewPassword" formControlName="confirmNewPassword" type="password">
          @if (changePasswordForm.get('confirmNewPassword')?.hasError('required') && (changePasswordForm.touched || changePasswordForm.dirty)) {
            <mat-error>O campo Ã© obrigatÃ³rio.</mat-error>
          }
          @if (changePasswordForm.hasError('passwordsMismatch') && (changePasswordForm.touched || changePasswordForm.dirty)) {
            <mat-error>As senhas nÃ£o conferem.
            </mat-error>
          }
        </mat-form-field>
      </div>

    </fieldset>
    <div class="button-container">
      <button mat-raised-button color="primary" type="submit" [disabled]="changePasswordForm.invalid">
        <mat-icon>save</mat-icon>
        Salvar
      </button>
    </div>
  </form>
</div>
